import _ from 'lodash';
import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  onValue,
  get,
  update,
  increment,
  query,
  orderByKey,
  limitToLast,
  endBefore,
} from 'firebase/database';
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';
import moment from 'moment-timezone';
import {
  getFirestore,
  collection,
  query as fsQuery,
  where,
  limit,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  addDoc,
  serverTimestamp,
  orderBy,
  Timestamp,
  deleteField,
} from 'firebase/firestore';
import { eventChannel } from 'redux-saga';
import {
  all,
  call,
  put,
  fork,
  takeEvery,
  take,
  select,
  takeLatest,
} from 'redux-saga/effects';
import axios from 'axios';
import actions from './actions';
import authActions from '../auth/actions';
import profileActions from '../profile/actions';
import memedActions from '../memed/actions';
import { siteConfig } from '../../settings';
import { notification } from '../../components';
import {
  JIRA_SYNC_BATCH_SIZE,
  formatVersion,
  getVersionSyncKey,
  normalizeChangelogEntry,
} from '../../helpers/changelog';

const ROOT_URL = process.env.REACT_APP_CLOUD_FUNCTIONS_ROOT_URL;

// A geração em lote pelo Jira roda até perto do timeout de 540 s da function.
const CHANGELOG_SYNC_TIMEOUT_MS = 540000;

const getIsProfessionalFromStore = (state) => state.Auth.professional;

const getMainUserFromStore = (state) => state.Auth.mainUser;

const getProfessionalProfileFromStore = (state) => state.Auth.professional;

const getSavedAllChangesPropFromStore = (state) => state.App.savedAllChangesProp;

const getOPenMemedFromStore = (state) => state.Memed.openMemed;

const getMaintenanceFromStore = (state) => state.App.maintenance;

const getProfileFromStore = (state) => state.Profile.profile;

const getCustomUserProfileFromStore = (state) => state.Profile.customUserProfile;

// Entradas do changelog, ponteiro da versão ativa no alerta de login, feedback
// por usuário, contagem de likes por item e likes do próprio usuário.
const CHANGELOG_ENTRIES_PATH = 'changelog';
const CHANGELOG_ACTIVE_PATH = 'changelogActive';
const CHANGELOG_FEEDBACK_PATH = 'changelogFeedback';
const CHANGELOG_LIKES_PATH = 'changelogLikes';
const CHANGELOG_USER_LIKES_PATH = 'changelogUserLikes';

// Cache local de "já vi" do alerta de login.
const CHANGELOG_SEEN_CACHE_KEY = 'changelogSeen';

function getIdToken() {
  const auth = getAuth();
  const { currentUser } = auth;
  return currentUser.getIdToken();
}

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function createVersionListener() {
  const db = getDatabase();
  const listener = eventChannel((emit) => {
    const versionRef = ref(db, 'version');
    const unsubscribe = onValue(versionRef, (req) => (
      emit(req.val() || null)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* checkAppVersionRequest() {
  yield takeEvery(actions.CHECK_APP_VERSION, function* () {
    const versionListener = yield call(createVersionListener);
    while (true) {
      const version = yield take(versionListener);
      if (version !== siteConfig.appVersion && version !== 'testing') {
        // let hasUnsavedChanges = false;
        // do {
        //   const savedAllChangesProp = yield select(getSavedAllChangesPropFromStore);
        //   const openMemed = yield select(getOPenMemedFromStore);
        //   let hasUnsavedChangesInsideLoop = false;
        //   Object.keys(savedAllChangesProp).forEach((patientId) => {
        //     Object.keys(savedAllChangesProp[patientId]).forEach((key) => {
        //       if (!savedAllChangesProp[patientId][key]) {
        //         hasUnsavedChangesInsideLoop = true;
        //       }
        //     });
        //   });
        //   if (hasUnsavedChangesInsideLoop || openMemed) {
        //     yield take([
        //       actions.CHANGE_SAVED_ALL_CHANGES,
        //       actions.CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD,
        //       actions.DISCARD_SAVED_ALL_CHANGES,
        //       memedActions.SET_OPEN_MEMED,
        //     ]);
        //   }
        //   hasUnsavedChanges = hasUnsavedChangesInsideLoop || openMemed;
        // } while (hasUnsavedChanges);
        // if (!hasUnsavedChanges) {
        //   console.info('Refreshing page!');
        //   yield put({
        //     type: actions.NEED_APP_RELOAD,
        //   });
        // }
        console.info('Refreshing page!');
        yield put({
          type: actions.NEED_APP_RELOAD,
        });
      }
    }
  });
}

export function* reloadApp() {
  yield takeEvery(actions.NEED_APP_RELOAD, function* () {
    yield call(sleep, 4000);
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
      window.location.reload();
    });
  });
}

function createServiceContractListener() {
  const db = getDatabase();
  const listener = eventChannel((emit) => {
    const serviceContractRef = ref(db, 'utils/serviceContract');
    const unsubscribe = onValue(serviceContractRef, (req) => (
      emit(req.val() || null)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* checkServiceContract() {
  let currentListener = null;
  yield takeLatest(authActions.LOGIN_SUCCESS, function* () {
    if (currentListener) {
      currentListener.close();
      currentListener = null;
    }
    const professional = yield select(getIsProfessionalFromStore);
    if (professional) {
      currentListener = yield call(createServiceContractListener);
      yield takeEvery(currentListener, function* (serviceContract) {
        if (serviceContract) {
          const { version, document } = serviceContract;
          yield put({
            type: actions.FETCH_SERVICE_CONTRACT_SUCCESS,
            payload: {
              version,
              document,
            },
          });
        }
      });
      yield take([
        actions.CANCEL_LISTENERS,
      ]);
      currentListener.close();
      currentListener = null;
    }
  });
}

function acceptServiceContactOnDB(idToken, mainUser) {
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    currentUser: currentUser.uid,
  };
  return axios.post(
    `${ROOT_URL}/acceptServiceContract`,
    bodyParameters,
    config,
  );
}

export function* acceptServiceContractRequest() {
  yield takeEvery(actions.ACCEPT_SERVICE_CONTRACT_REQUEST, function* () {
    try {
      yield put({ type: actions.SAVING_SERVICE_CONTRACT });
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const { status } = yield call(
        acceptServiceContactOnDB,
        idToken,
        mainUser,
      );
      if (status === 201) {
        yield all([
          put({ type: actions.ACCEPT_SERVICE_CONTRACT_SUCCESS }),
          put({ type: profileActions.PROFILE_INFO_REQUEST }),
        ]);
      }
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.ACCEPT_SERVICE_CONTRACT_ERROR });
      notification(
        'error',
        'Algo deu errado para salvar o contrato. Tente novamente mais tarde.',
      );
    }
  });
}

function fetchCompleteChangelogFromDB() {
  const db = getDatabase();
  return get(ref(db, CHANGELOG_ENTRIES_PATH));
}

function fetchActiveChangelogKeyFromDB() {
  const db = getDatabase();
  return get(ref(db, CHANGELOG_ACTIVE_PATH));
}

function fetchChangelogEntryFromDB(entryKey) {
  const db = getDatabase();
  return get(ref(db, `${CHANGELOG_ENTRIES_PATH}/${entryKey}`));
}

function readSeenChangelogKey() {
  return localStorage.getItem(CHANGELOG_SEEN_CACHE_KEY);
}

function writeSeenChangelogKey(entryKey) {
  return localStorage.setItem(CHANGELOG_SEEN_CACHE_KEY, entryKey);
}

// Alerta de login: mostra a versão apontada em changelogActive até o usuário
// fechar o modal, quando a chave dela vai para o cache local.
export function* requestSystemUpdatesChangelog() {
  yield takeEvery([actions.FETCH_SYSTEM_UPDATES_CHANGELOG, authActions.LOGIN_SUCCESS], function* (action) {
    try {
      let professional = yield select(getProfessionalProfileFromStore);
      if (!professional) {
        yield take(authActions.LOGIN_SUCCESS);
        professional = yield select(getProfessionalProfileFromStore);
      }
      if (!professional) {
        return;
      }
      const completeChangelog = action?.payload?.completeChangelog || false;

      if (completeChangelog) {
        const [changelogSnapshot, activeSnapshot] = yield all([
          call(fetchCompleteChangelogFromDB),
          call(fetchActiveChangelogKeyFromDB),
        ]);
        yield put({
          type: actions.FETCH_COMPLETE_SYSTEM_UPDATES_CHANGELOG_SUCCESS,
          payload: changelogSnapshot.val(),
        });
        yield put({
          type: actions.FETCH_ACTIVE_CHANGELOG_SUCCESS,
          payload: activeSnapshot.val() || null,
        });
        return;
      }

      const activeSnapshot = yield call(fetchActiveChangelogKeyFromDB);
      const activeKey = activeSnapshot.val();
      const seenKey = yield call(readSeenChangelogKey);
      if (!activeKey || activeKey === seenKey) {
        return;
      }
      const entrySnapshot = yield call(fetchChangelogEntryFromDB, activeKey);
      if (entrySnapshot.exists()) {
        yield put({
          type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG_SUCCESS,
          payload: { [activeKey]: entrySnapshot.val() },
        });
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

export function* markChangelogSeenRequest() {
  yield takeEvery(actions.MARK_CHANGELOG_SEEN, function* (action) {
    try {
      yield call(writeSeenChangelogKey, action.payload.entryKey);
    } catch (error) {
      console.warn(error);
    }
  });
}

export function* setActiveChangelogRequest() {
  yield takeEvery(actions.SET_ACTIVE_CHANGELOG, function* (action) {
    const { entryKey } = action.payload;
    try {
      const db = getDatabase();
      yield call(() => update(ref(db), { [CHANGELOG_ACTIVE_PATH]: entryKey || null }));
      yield put({
        type: actions.SET_ACTIVE_CHANGELOG_SUCCESS,
        payload: entryKey || null,
      });
      notification(
        'success',
        entryKey ? 'Alerta ativado para esta versão.' : 'Alerta de atualização desativado.',
      );
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.SET_ACTIVE_CHANGELOG_ERROR });
      notification('error', 'Não foi possível alterar o alerta ativo. Tente novamente.');
    }
  });
}

function uploadChangelogImage(file) {
  const storage = getStorage();
  const cleanName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const fileRef = storageRef(storage, `public/changelog/${Date.now()}-${cleanName}`);
  return uploadBytes(fileRef, file).then((snapshot) => getDownloadURL(snapshot.ref));
}

export function* saveSystemUpdateRequest() {
  yield takeEvery(actions.SAVE_SYSTEM_UPDATE, function* (action) {
    try {
      const {
        key,
        version,
        title,
        description,
        authors,
        publishedAt,
        items,
        status,
        imageFile,
        imageUrl,
        source,
        jiraKeys,
        generatedAt,
      } = action.payload;
      const db = getDatabase();

      let entryKey = key;
      if (!entryKey) {
        entryKey = moment(publishedAt).format('YYYY-MM-DD');
        const existing = yield call(() => get(ref(db, `${CHANGELOG_ENTRIES_PATH}/${entryKey}`)));
        if (existing.exists()) {
          entryKey = `${moment(publishedAt).format('YYYY-MM-DD')}T${moment().format('HH:mm:ss')}`;
        }
      }

      let finalImageUrl = imageUrl || null;
      if (imageFile) {
        finalImageUrl = yield call(uploadChangelogImage, imageFile);
      }

      const entry = {
        version,
        title,
        description: description || null,
        authors,
        publishedAt,
        items,
        imageUrl: finalImageUrl,
        status,
        visible: status === 'published',
        new: items.some((item) => item.type === 'new'),
        bugfix: items.some((item) => item.type === 'fix'),
        changes: items.map((item) => ({
          title: item.title,
          description: item.description || '',
        })),
        source: source || null,
        jiraKeys: jiraKeys || null,
        generatedAt: generatedAt || null,
      };

      yield call(() => update(ref(db), { [`${CHANGELOG_ENTRIES_PATH}/${entryKey}`]: entry }));
      yield put({ type: actions.SAVE_SYSTEM_UPDATE_SUCCESS });
      yield put({
        type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG,
        payload: { completeChangelog: true },
      });
      notification(
        'success',
        status === 'published' ? 'Atualização publicada.' : 'Rascunho salvo.',
      );
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.SAVE_SYSTEM_UPDATE_ERROR });
      notification(
        'error',
        'Não foi possível salvar a atualização. Tente novamente.',
      );
    }
  });
}

function resolveFeedbackAuthorName(profile, customUserProfile, currentUser) {
  if (customUserProfile?.fullName) {
    return customUserProfile.fullName;
  }
  const fullName = `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim();
  if (fullName) {
    return fullName;
  }
  return currentUser?.displayName || currentUser?.email || null;
}

function isPermissionDenied(error) {
  return String(error?.code || error?.message || '').includes('PERMISSION_DENIED');
}

function fetchMyChangelogFeedbackFromDB(uid) {
  const db = getDatabase();
  return get(ref(db, `${CHANGELOG_FEEDBACK_PATH}/${uid}`));
}

// Um feedback por usuário e por versão: a chave é o uid e a regra do RTDB
// só aceita criação (!data.exists()).
export function* sendChangelogFeedbackRequest() {
  yield takeEvery(actions.SEND_CHANGELOG_FEEDBACK, function* (action) {
    const { entryKey, version, message } = action.payload;
    try {
      const { currentUser } = getAuth();
      const mainUser = yield select(getMainUserFromStore);
      const profile = yield select(getProfileFromStore);
      const customUserProfile = yield select(getCustomUserProfileFromStore);
      const db = getDatabase();
      const feedback = {
        version: version || null,
        message: message.trim(),
        accountUid: mainUser || currentUser.uid,
        authorName: resolveFeedbackAuthorName(profile, customUserProfile, currentUser),
        authorEmail: currentUser.email || null,
        createdAt: Date.now(),
        read: false,
      };
      yield call(() => update(ref(db), {
        [`${CHANGELOG_FEEDBACK_PATH}/${currentUser.uid}/${entryKey}`]: feedback,
      }));
      yield put({
        type: actions.SEND_CHANGELOG_FEEDBACK_SUCCESS,
        payload: {
          entryKey,
          feedback: { ...feedback, actorUid: currentUser.uid, entryKey },
        },
      });
      notification('success', 'Mensagem enviada para a equipe do sistema.');
    } catch (error) {
      console.warn(error);
      if (isPermissionDenied(error)) {
        yield put({
          type: actions.SEND_CHANGELOG_FEEDBACK_SUCCESS,
          payload: { entryKey, feedback: null },
        });
        yield put({ type: actions.FETCH_MY_CHANGELOG_FEEDBACK });
        notification('info', 'Você já enviou uma mensagem sobre esta versão.');
        return;
      }
      yield put({
        type: actions.SEND_CHANGELOG_FEEDBACK_ERROR,
        payload: { entryKey },
      });
      notification(
        'error',
        'Não foi possível enviar a mensagem. Tente novamente.',
      );
    }
  });
}

export function* fetchMyChangelogFeedbackRequest() {
  yield takeLatest(actions.FETCH_MY_CHANGELOG_FEEDBACK, function* () {
    try {
      const { currentUser } = getAuth();
      if (!currentUser) {
        yield put({ type: actions.FETCH_MY_CHANGELOG_FEEDBACK_SUCCESS, payload: {} });
        return;
      }
      const snapshot = yield call(fetchMyChangelogFeedbackFromDB, currentUser.uid);
      const byEntry = snapshot.val() || {};
      const feedbackByEntry = {};
      Object.keys(byEntry).forEach((entryKey) => {
        feedbackByEntry[entryKey] = {
          ...byEntry[entryKey],
          actorUid: currentUser.uid,
          entryKey,
        };
      });
      yield put({
        type: actions.FETCH_MY_CHANGELOG_FEEDBACK_SUCCESS,
        payload: feedbackByEntry,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.FETCH_MY_CHANGELOG_FEEDBACK_ERROR });
    }
  });
}

function fetchChangelogFeedbackFromDB() {
  const db = getDatabase();
  return get(ref(db, CHANGELOG_FEEDBACK_PATH));
}

export function* fetchChangelogFeedbackRequest() {
  yield takeLatest(actions.FETCH_CHANGELOG_FEEDBACK, function* () {
    try {
      const snapshot = yield call(fetchChangelogFeedbackFromDB);
      const byActor = snapshot.val() || {};
      const feedbackList = [];
      Object.keys(byActor).forEach((actorUid) => {
        Object.keys(byActor[actorUid] || {}).forEach((entryKey) => {
          feedbackList.push({
            ...byActor[actorUid][entryKey],
            id: `${actorUid}:${entryKey}`,
            actorUid,
            entryKey,
          });
        });
      });
      feedbackList.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
      yield put({
        type: actions.FETCH_CHANGELOG_FEEDBACK_SUCCESS,
        payload: feedbackList,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.FETCH_CHANGELOG_FEEDBACK_ERROR });
      notification(
        'error',
        'Não foi possível carregar os feedbacks das atualizações.',
      );
    }
  });
}

export function* markChangelogFeedbackReadRequest() {
  yield takeEvery(actions.MARK_CHANGELOG_FEEDBACK_READ, function* (action) {
    const {
      id,
      actorUid,
      entryKey,
      read,
    } = action.payload;
    try {
      const db = getDatabase();
      yield call(() => update(ref(db), {
        [`${CHANGELOG_FEEDBACK_PATH}/${actorUid}/${entryKey}/read`]: read,
      }));
      yield put({
        type: actions.MARK_CHANGELOG_FEEDBACK_READ_SUCCESS,
        payload: { id, read },
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.MARK_CHANGELOG_FEEDBACK_READ_ERROR });
      notification(
        'error',
        'Não foi possível atualizar o feedback. Tente novamente.',
      );
    }
  });
}

// Com entryKeys lê só as contagens dessas versões (tela paginada); sem, o nó inteiro.
function fetchChangelogLikesFromDB(uid, entryKeys) {
  const db = getDatabase();
  const readCounts = entryKeys.length
    ? Promise.all(entryKeys.map((entryKey) => get(ref(db, `${CHANGELOG_LIKES_PATH}/${entryKey}`))))
      .then((snapshots) => snapshots.reduce((acc, snapshot, index) => (
        { ...acc, [entryKeys[index]]: snapshot.val() }
      ), {}))
    : get(ref(db, CHANGELOG_LIKES_PATH)).then((snapshot) => snapshot.val() || {});
  return Promise.all([
    readCounts,
    get(ref(db, `${CHANGELOG_USER_LIKES_PATH}/${uid}`)),
  ]);
}

export function* fetchChangelogLikesRequest() {
  yield takeEvery(actions.FETCH_CHANGELOG_LIKES, function* (action) {
    try {
      const { currentUser } = getAuth();
      if (!currentUser) {
        return;
      }
      const entryKeys = action.payload?.entryKeys || [];
      const [countsByEntry, mineSnapshot] = yield call(
        fetchChangelogLikesFromDB,
        currentUser.uid,
        entryKeys,
      );
      const counts = {};
      Object.keys(countsByEntry).forEach((entryKey) => {
        Object.keys(countsByEntry[entryKey] || {}).forEach((itemId) => {
          counts[`${entryKey}/${itemId}`] = countsByEntry[entryKey][itemId]?.count || 0;
        });
      });
      const mineByEntry = mineSnapshot.val() || {};
      const mine = {};
      Object.keys(mineByEntry).forEach((entryKey) => {
        Object.keys(mineByEntry[entryKey] || {}).forEach((itemId) => {
          if (mineByEntry[entryKey][itemId]) {
            mine[`${entryKey}/${itemId}`] = true;
          }
        });
      });
      yield put({
        type: actions.FETCH_CHANGELOG_LIKES_SUCCESS,
        payload: { counts, mine },
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.FETCH_CHANGELOG_LIKES_ERROR });
    }
  });
}

export function* toggleChangelogLikeRequest() {
  yield takeEvery(actions.TOGGLE_CHANGELOG_LIKE, function* (action) {
    const { entryKey, itemId, liked } = action.payload;
    try {
      const { currentUser } = getAuth();
      const db = getDatabase();
      yield call(() => update(ref(db), {
        [`${CHANGELOG_USER_LIKES_PATH}/${currentUser.uid}/${entryKey}/${itemId}`]: liked ? true : null,
        [`${CHANGELOG_LIKES_PATH}/${entryKey}/${itemId}/count`]: increment(liked ? 1 : -1),
      }));
      yield put({
        type: actions.TOGGLE_CHANGELOG_LIKE_SUCCESS,
        payload: action.payload,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.TOGGLE_CHANGELOG_LIKE_ERROR,
        payload: action.payload,
      });
      notification('error', 'Não foi possível registrar sua reação. Tente novamente.');
    }
  });
}

function createMaintenanceListener() {
  const db = getDatabase();
  const listener = eventChannel((emit) => {
    const maintenanceRef = ref(db, 'maintenance');
    const unsubscribe = onValue(maintenanceRef, (req) => (
      emit(req.val() || null)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* checkMaintenanceRequest() {
  yield takeEvery(actions.CHECK_APP_VERSION, function* () {
    const maintenanceListener = yield call(createMaintenanceListener);
    while (true) {
      const maintenance = yield take(maintenanceListener);
      const maintenanceFromStore = yield select(getMaintenanceFromStore);
      if (maintenance?.active) {
        let hasUnsavedChanges = false;
        const savedAllChangesProp = yield select(getSavedAllChangesPropFromStore);
        const openMemed = yield select(getOPenMemedFromStore);
        Object.keys(savedAllChangesProp).forEach((patientId) => {
          Object.keys(savedAllChangesProp[patientId]).forEach((key) => {
            if (!savedAllChangesProp[patientId][key]) {
              hasUnsavedChanges = true;
            }
          });
        });
        if ((hasUnsavedChanges || openMemed) && !_.isUndefined(maintenanceFromStore)) {
          notification(
            'warning',
            'O Meagenda vai entrar em manutenção',
            'Em 3 minutos o sistema ficará fora do ar. Salve suas alterações antes disso.',
            180,
          );
          yield call(sleep, 180000);
        }
        yield all([
          // put({
          //   type: actions.DISCARD_SAVED_ALL_CHANGES,
          // }),
          put({
            type: memedActions.SET_OPEN_MEMED,
            payload: false,
          }),
        ]);
      }
      yield put({
        type: actions.SET_MAINTENANCE,
        payload: maintenance,
      });
    }
  });
}

function checkShowPopoverComponentToPrint() {
  return JSON.parse(localStorage.getItem('already_shown_popover_component_to_print'));
}

export function* checkShowPopoverComponentToPrintRequest() {
  yield takeEvery(authActions.LOGIN_SUCCESS, function* () {
    try {
      let professional = yield select(getProfessionalProfileFromStore);
      if (!professional) {
        yield take(authActions.LOGIN_SUCCESS);
        professional = yield select(getProfessionalProfileFromStore);
      }
      if (professional) {
        const alreadyShownPopoverComponentToPrint = yield call(checkShowPopoverComponentToPrint);
        yield put({
          type: actions.SET_SHOW_POPOVER_COMPONENT_TO_PRINT,
          payload: {
            alreadyShownPopoverComponentToPrint,
          },
        });
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

function setCheckShowPopoverComponentToPrint() {
  return localStorage.setItem('already_shown_popover_component_to_print', JSON.stringify(true));
}

export function* setShowPopoverComponentToPrintRequest() {
  yield takeEvery(actions.SAVE_ON_CACHE_SHOW_POPOVER_COMPONENT_TO_PRINT, function* () {
    try {
      yield call(setCheckShowPopoverComponentToPrint);
      yield put({
        type: actions.SET_SHOW_POPOVER_COMPONENT_TO_PRINT,
        payload: {
          alreadyShownPopoverComponentToPrint: true,
        },
      });
    } catch (error) {
      console.warn(error);
    }
  });
}

function updateSystemAlertOnDB(alert) {
  const db = getDatabase();
  const dbRef = ref(db);
  const updates = {};
  updates['/alert'] = alert;
  return update(dbRef, updates);
}

export function* updateSystemAlert() {
  yield takeEvery(actions.UPDATE_SYSTEM_ALERT, function* (action) {
    try {
      yield call(
        updateSystemAlertOnDB,
        action.payload,
      );
      yield put({
        type: actions.UPDATE_SYSTEM_ALERT_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.UPDATE_SYSTEM_ALERT_ERROR });
    }
  });
}

function createSystemAlertListener() {
  const db = getDatabase();
  const listener = eventChannel((emit) => {
    const alertRef = ref(db, 'alert');
    const unsubscribe = onValue(alertRef, (req) => (
      emit(req.val() || null)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* checkSystemAlert() {
  let currentListener = null;
  yield takeLatest(authActions.LOGIN_SUCCESS, function* () {
    if (currentListener) {
      currentListener.close();
      currentListener = null;
    }
    const professional = yield select(getIsProfessionalFromStore);
    if (professional) {
      currentListener = yield call(createSystemAlertListener);
      yield takeEvery(currentListener, function* (alert) {
        if (alert) {
          yield put({
            type: actions.FETCH_SYSTEM_ALERT_SUCCESS,
            payload: alert,
          });
        }
      });
      yield take([
        actions.CANCEL_LISTENERS,
      ]);
      currentListener.close();
      currentListener = null;
    }
  });
}

// Admin Module Manager Sagas
function searchProfessionalsFromFirestore(searchTerm) {
  const fs = getFirestore();
  const normalizedSearch = searchTerm
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const colRef = collection(fs, 'professionals');
  const q = fsQuery(
    colRef,
    where('keywords', 'array-contains', normalizedSearch),
    limit(20),
  );
  return getDocs(q);
}

function getProfessionalDataFromFirestore(professionalUid) {
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid);
  return getDoc(docRef);
}

function getCustomUsersFromFirestore(professionalUid) {
  const fs = getFirestore();
  const colRef = collection(fs, 'professionals', professionalUid, 'customUsers');
  return getDocs(colRef);
}

function getUserEmailFromAuth(idToken, uid) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  return axios.post(
    `${ROOT_URL}/getUserEmail`,
    { uid },
    config,
  );
}

function getUsersAuthStatus(idToken, uids) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  return axios.post(
    `${ROOT_URL}/getUsersStatus`,
    { uids },
    config,
  );
}

function setUserEnabledOnAuth(idToken, uid, enabled) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  return axios.post(
    `${ROOT_URL}/setUserEnabled`,
    { uid, enabled },
    config,
  );
}

function getModulePermissionsFromFirestore(professionalUid, moduleType) {
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid, moduleType, 'users');
  return getDoc(docRef);
}

// Retorna null se nada mudou em relação a `prev` (o merge só grava as chaves de
// `permissions`): write sem diff dispararia o trigger de billing à toa.
function saveModulePermissionsToFirestore(professionalUid, moduleType, permissions, prev) {
  const unchanged = Object.entries(permissions || {})
    .every(([uid, enabled]) => (prev || {})[uid] === enabled);
  if (unchanged) return null;
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid, moduleType, 'users');
  return setDoc(docRef, permissions, { merge: true });
}

function getModuleFreePeriodsFromFirestore(professionalUid, moduleType) {
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid, moduleType, 'freePeriods');
  return getDoc(docRef);
}

// Persiste o doc freePeriods de um módulo. `next` é o map { uid: ISOstring } do
// estado atual; `prev` o map anterior — uids que sumiram viram deleteField()
// (merge não remove sozinho). Valores presentes viram Timestamp. Retorna null se
// não há nada pra escrever (evita write desnecessário que dispararia recompute).
function saveModuleFreePeriodsToFirestore(professionalUid, moduleType, next, prev) {
  const payload = {};
  Object.entries(next || {}).forEach(([uid, iso]) => {
    if (iso) payload[uid] = Timestamp.fromDate(new Date(iso));
  });
  Object.keys(prev || {}).forEach((uid) => {
    if (!next || next[uid] == null) payload[uid] = deleteField();
  });
  if (Object.keys(payload).length === 0) return null;
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid, moduleType, 'freePeriods');
  return setDoc(docRef, payload, { merge: true });
}

function updateMaxCustomHealthProfessionalsOnFirestore(professionalUid, maxValue) {
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', professionalUid);
  return updateDoc(docRef, { maxCustomHealthProfessionals: maxValue });
}

function saveModuleHistoryToFirestore(professionalUid, historyEntry) {
  const fs = getFirestore();
  const historyCollection = collection(fs, 'professionals', professionalUid, 'moduleHistory');
  return addDoc(historyCollection, {
    ...historyEntry,
    timestamp: serverTimestamp(),
  });
}

function fetchModuleHistoryFromFirestore(professionalUid) {
  const fs = getFirestore();
  const historyCollection = collection(fs, 'professionals', professionalUid, 'moduleHistory');
  const q = fsQuery(historyCollection, orderBy('timestamp', 'desc'), limit(50));
  return getDocs(q);
}

export function* searchProfessionalsAdminRequest() {
  yield takeLatest(actions.SEARCH_PROFESSIONALS_ADMIN, function* (action) {
    try {
      const { searchTerm } = action.payload;
      if (!searchTerm || searchTerm.length < 2) {
        yield put({
          type: actions.SEARCH_PROFESSIONALS_ADMIN_SUCCESS,
          payload: { professionals: [] },
        });
        return;
      }
      const result = yield call(searchProfessionalsFromFirestore, searchTerm);
      const professionals = [];
      result.forEach((docSnap) => {
        professionals.push({
          id: docSnap.id,
          ...docSnap.data(),
        });
      });
      yield put({
        type: actions.SEARCH_PROFESSIONALS_ADMIN_SUCCESS,
        payload: { professionals },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.SEARCH_PROFESSIONALS_ADMIN_ERROR,
        payload: error.message,
      });
    }
  });
}

export function* fetchProfessionalDataAdminRequest() {
  yield takeLatest(actions.FETCH_PROFESSIONAL_DATA_ADMIN, function* (action) {
    try {
      const { professionalUid } = action.payload;

      // Fetch professional data
      const professionalDoc = yield call(getProfessionalDataFromFirestore, professionalUid);
      const professionalData = professionalDoc.exists()
        ? { id: professionalDoc.id, ...professionalDoc.data() }
        : null;

      // Fetch custom users
      const customUsersResult = yield call(getCustomUsersFromFirestore, professionalUid);
      const customUsers = [];
      customUsersResult.forEach((docSnap) => {
        customUsers.push({
          id: docSnap.id,
          ...docSnap.data(),
        });
      });

      yield put({
        type: actions.FETCH_PROFESSIONAL_DATA_ADMIN_SUCCESS,
        payload: {
          professional: professionalData,
          customUsers,
        },
      });

      // Also fetch module permissions
      yield put({
        type: actions.FETCH_PROFESSIONAL_MODULES_ADMIN,
        payload: { professionalUid },
      });

      // Fetch the principal account email and Auth status using its uid (each with own loading)
      if (professionalData) {
        yield put({ type: actions.FETCH_PROFESSIONAL_EMAIL_ADMIN });
        yield put({ type: actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN });
        const idToken = yield call(getIdToken);

        try {
          const emailResponse = yield call(getUserEmailFromAuth, idToken, professionalData.id);
          yield put({
            type: actions.FETCH_PROFESSIONAL_EMAIL_ADMIN_SUCCESS,
            payload: { email: emailResponse?.data || professionalData.email || '' },
          });
        } catch (emailError) {
          console.warn('Failed to fetch principal email from Auth', emailError);
          yield put({
            type: actions.FETCH_PROFESSIONAL_EMAIL_ADMIN_ERROR,
            payload: emailError.message,
          });
        }

        try {
          // Collect uids of the principal and all secondary (custom) users
          const statusUids = [
            professionalData.id,
            ...customUsers.map((user) => user.id),
          ].filter(Boolean);
          const statusResponse = yield call(getUsersAuthStatus, idToken, statusUids);
          const foundUsers = statusResponse?.data?.users || [];
          const notFoundUids = statusResponse?.data?.notFound || [];

          // Build a map keyed by uid so each row (principal + secondary) can read its status
          const authStatusMap = {};
          foundUsers.forEach((authUser) => {
            authStatusMap[authUser.uid] = {
              enabled: authUser.enabled,
              lastSignInTime: authUser.lastSignInTime,
              lastRefreshTime: authUser.lastRefreshTime,
              notFound: false,
            };
          });
          notFoundUids.forEach((uid) => {
            authStatusMap[uid] = { enabled: false, notFound: true };
          });

          yield put({
            type: actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_SUCCESS,
            payload: { authStatusMap },
          });
        } catch (statusError) {
          console.warn('Failed to fetch Auth status', statusError);
          yield put({
            type: actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_ERROR,
            payload: statusError.message,
          });
        }
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.FETCH_PROFESSIONAL_DATA_ADMIN_ERROR,
        payload: error.message,
      });
    }
  });
}

export function* fetchProfessionalModulesAdminRequest() {
  yield takeLatest(actions.FETCH_PROFESSIONAL_MODULES_ADMIN, function* (action) {
    try {
      const { professionalUid } = action.payload;

      // Fetch permissions + free periods for all 4 modules
      const [
        twilioDoc, aiDoc, aiRecorderDoc, tvDoc,
        twilioFree, aiFree, aiRecorderFree, tvFree,
      ] = yield all([
        call(getModulePermissionsFromFirestore, professionalUid, 'twilio'),
        call(getModulePermissionsFromFirestore, professionalUid, 'ai'),
        call(getModulePermissionsFromFirestore, professionalUid, 'aiRecorder'),
        call(getModulePermissionsFromFirestore, professionalUid, 'tv'),
        call(getModuleFreePeriodsFromFirestore, professionalUid, 'twilio'),
        call(getModuleFreePeriodsFromFirestore, professionalUid, 'ai'),
        call(getModuleFreePeriodsFromFirestore, professionalUid, 'aiRecorder'),
        call(getModuleFreePeriodsFromFirestore, professionalUid, 'tv'),
      ]);

      const modules = {
        twilio: twilioDoc.exists() ? twilioDoc.data() : {},
        ai: aiDoc.exists() ? aiDoc.data() : {},
        aiRecorder: aiRecorderDoc.exists() ? aiRecorderDoc.data() : {},
        tv: tvDoc.exists() ? tvDoc.data() : {},
      };

      // Converte { uid: Timestamp } → { uid: ISOstring } (serializável no redux).
      const toIsoMap = (snap) => {
        if (!snap.exists()) return {};
        const out = {};
        Object.entries(snap.data() || {}).forEach(([uid, ts]) => {
          const date = ts && typeof ts.toDate === 'function' ? ts.toDate() : new Date(ts);
          if (date && !Number.isNaN(date.getTime())) out[uid] = date.toISOString();
        });
        return out;
      };
      const freePeriods = {
        twilio: toIsoMap(twilioFree),
        ai: toIsoMap(aiFree),
        aiRecorder: toIsoMap(aiRecorderFree),
        tv: toIsoMap(tvFree),
      };

      yield put({
        type: actions.FETCH_PROFESSIONAL_MODULES_ADMIN_SUCCESS,
        payload: { modules, freePeriods },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.FETCH_PROFESSIONAL_MODULES_ADMIN_ERROR,
        payload: error.message,
      });
    }
  });
}

export function* updateProfessionalModulesAdminRequest() {
  yield takeLatest(actions.UPDATE_PROFESSIONAL_MODULES_ADMIN, function* (action) {
    try {
      const {
        professionalUid, modules, freePeriods, maxCustomHealthProfessionals,
      } = action.payload;

      // Get previous state for history comparison
      const moduleManager = yield select((state) => state.App.moduleManager);
      const previousModules = moduleManager.modules || {};
      const previousFreePeriods = moduleManager.freePeriods || {};
      const previousMax = moduleManager.selectedProfessional?.maxCustomHealthProfessionals || 0;

      // Get current admin user info
      const auth = getAuth();
      const adminUser = auth.currentUser;

      // IMPORTANTE: grava freePeriods ANTES de users. Quando o admin ativa um
      // módulo e marca "grátis até" no mesmo Salvar, o trigger de `users` recalcula
      // o valor (pro-rata é dirigido pelo delta de valor). Se o freePeriods já
      // estiver commitado, o computeProfileValue desse trigger vê o seat como
      // grátis → delta 0 → não cobra pró-rata. Ordem inversa abriria corrida
      // (cobrança indevida do seat que era pra ser grátis). Cada helper retorna
      // null se não houve diff — evita write/recompute desnecessário.
      yield all([
        call(saveModuleFreePeriodsToFirestore, professionalUid, 'twilio', (freePeriods || {}).twilio || {}, previousFreePeriods.twilio || {}),
        call(saveModuleFreePeriodsToFirestore, professionalUid, 'ai', (freePeriods || {}).ai || {}, previousFreePeriods.ai || {}),
        call(saveModuleFreePeriodsToFirestore, professionalUid, 'aiRecorder', (freePeriods || {}).aiRecorder || {}, previousFreePeriods.aiRecorder || {}),
        call(saveModuleFreePeriodsToFirestore, professionalUid, 'tv', (freePeriods || {}).tv || {}, previousFreePeriods.tv || {}),
      ]);

      // Grava só os módulos que mudaram (depois do freePeriods — ver nota acima).
      yield all([
        call(saveModulePermissionsToFirestore, professionalUid, 'twilio', modules.twilio || {}, previousModules.twilio || {}),
        call(saveModulePermissionsToFirestore, professionalUid, 'ai', modules.ai || {}, previousModules.ai || {}),
        call(saveModulePermissionsToFirestore, professionalUid, 'aiRecorder', modules.aiRecorder || {}, previousModules.aiRecorder || {}),
        call(saveModulePermissionsToFirestore, professionalUid, 'tv', modules.tv || {}, previousModules.tv || {}),
      ]);

      // Update maxCustomHealthProfessionals if provided
      if (maxCustomHealthProfessionals !== undefined && maxCustomHealthProfessionals !== null) {
        yield call(
          updateMaxCustomHealthProfessionalsOnFirestore,
          professionalUid,
          maxCustomHealthProfessionals,
        );
      }

      // Calculate only the changed values for history
      const moduleChanges = [];
      const moduleTypes = ['twilio', 'ai', 'aiRecorder', 'tv'];

      // Get users list to find names
      const { customUsers, selectedProfessional: professional } = moduleManager;
      const getUserName = (userId) => {
        if (userId === professional?.id) {
          return professional.fullName
            || `${professional.firstName || ''} ${professional.lastName || ''}`.trim()
            || professional.name
            || null;
        }
        const customUser = customUsers.find((u) => u.id === userId);
        return customUser?.fullName || customUser?.name || null;
      };

      moduleTypes.forEach((moduleType) => {
        const prevModule = previousModules[moduleType] || {};
        const newModule = modules[moduleType] || {};

        // Get all user IDs from both previous and new
        const allUserIds = new Set([
          ...Object.keys(prevModule),
          ...Object.keys(newModule),
        ]);

        allUserIds.forEach((userId) => {
          const prevValue = !!prevModule[userId];
          const newValue = !!newModule[userId];

          if (prevValue !== newValue) {
            const userName = getUserName(userId);
            moduleChanges.push({
              module: moduleType,
              userId,
              userName: userName || null,
              from: prevValue,
              to: newValue,
            });
          }
        });
      });

      // Calculate free-period changes for history (set/clear/altera data)
      const freePeriodChanges = [];
      moduleTypes.forEach((moduleType) => {
        const prevFree = previousFreePeriods[moduleType] || {};
        const newFree = (freePeriods || {})[moduleType] || {};
        const allUserIds = new Set([
          ...Object.keys(prevFree),
          ...Object.keys(newFree),
        ]);
        allUserIds.forEach((userId) => {
          const fromFree = prevFree[userId] || null;
          const toFree = newFree[userId] || null;
          if (fromFree !== toFree) {
            freePeriodChanges.push({
              module: moduleType,
              userId,
              userName: getUserName(userId) || null,
              fromFree,
              toFree,
            });
          }
        });
      });

      // Only save history if there are actual changes
      const maxChanged = previousMax !== maxCustomHealthProfessionals;
      const hasModuleChanges = moduleChanges.length > 0;
      const hasFreePeriodChanges = freePeriodChanges.length > 0;

      if (maxChanged || hasModuleChanges || hasFreePeriodChanges) {
        const historyEntry = {
          adminId: adminUser?.uid || 'unknown',
          adminEmail: adminUser?.email || 'unknown',
          changes: {},
        };

        if (maxChanged) {
          historyEntry.changes.maxCustomHealthProfessionals = {
            from: previousMax,
            to: maxCustomHealthProfessionals,
          };
        }

        if (hasModuleChanges) {
          historyEntry.changes.modules = moduleChanges;
        }

        if (hasFreePeriodChanges) {
          historyEntry.changes.freePeriods = freePeriodChanges;
        }

        yield call(saveModuleHistoryToFirestore, professionalUid, historyEntry);
      }

      yield put({
        type: actions.UPDATE_PROFESSIONAL_MODULES_ADMIN_SUCCESS,
      });

      // Refresh data after successful save
      yield put({
        type: actions.FETCH_PROFESSIONAL_DATA_ADMIN,
        payload: { professionalUid },
      });
      yield put({
        type: actions.FETCH_MODULE_HISTORY_ADMIN,
        payload: { professionalUid },
      });

      notification(
        'success',
        'Módulos atualizados com sucesso!',
      );
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.UPDATE_PROFESSIONAL_MODULES_ADMIN_ERROR,
        payload: error.message,
      });
      notification(
        'error',
        'Erro ao atualizar módulos',
        error.message,
      );
    }
  });
}

export function* fetchModuleHistoryAdminRequest() {
  yield takeLatest(actions.FETCH_MODULE_HISTORY_ADMIN, function* (action) {
    try {
      const { professionalUid } = action.payload;
      const historySnapshot = yield call(fetchModuleHistoryFromFirestore, professionalUid);
      const history = [];
      historySnapshot.forEach((historyDoc) => {
        history.push({
          id: historyDoc.id,
          ...historyDoc.data(),
          timestamp: historyDoc.data().timestamp?.toDate?.() || null,
        });
      });
      yield put({
        type: actions.FETCH_MODULE_HISTORY_ADMIN_SUCCESS,
        payload: { history },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.FETCH_MODULE_HISTORY_ADMIN_ERROR,
        payload: error.message,
      });
    }
  });
}

export function* setUserEnabledAdminRequest() {
  yield takeLatest(actions.SET_USER_ENABLED_ADMIN, function* (action) {
    try {
      const { uid, enabled } = action.payload;

      // Capture the state BEFORE the toggle so the history records the real "from" value.
      const moduleManager = yield select((state) => state.App.moduleManager);
      const professional = moduleManager.selectedProfessional;
      const previousEnabled = moduleManager.authStatusMap?.[uid]?.enabled;

      const idToken = yield call(getIdToken);
      const response = yield call(setUserEnabledOnAuth, idToken, uid, enabled);
      const newEnabled = response?.data?.enabled ?? enabled;
      yield put({
        type: actions.SET_USER_ENABLED_ADMIN_SUCCESS,
        payload: {
          uid,
          enabled: newEnabled,
          lastSignInTime: response?.data?.lastSignInTime || null,
          lastRefreshTime: response?.data?.lastRefreshTime || null,
        },
      });

      // Register the activation/deactivation in the professional's history
      if (professional) {
        const isOwner = uid === professional.id;
        const customUser = moduleManager.customUsers?.find((user) => user.id === uid);
        const userName = isOwner
          ? (professional.fullName
            || `${professional.firstName || ''} ${professional.lastName || ''}`.trim()
            || professional.name
            || 'Profissional Principal')
          : (customUser?.fullName || customUser?.name || uid);

        const auth = getAuth();
        const adminUser = auth.currentUser;
        const historyEntry = {
          adminId: adminUser?.uid || 'unknown',
          adminEmail: adminUser?.email || 'unknown',
          changes: {
            accountStatus: {
              userId: uid,
              userName,
              isOwner,
              from: previousEnabled ?? !newEnabled,
              to: newEnabled,
            },
          },
        };
        // History always lives under the principal account document.
        yield call(saveModuleHistoryToFirestore, professional.id, historyEntry);
        yield put({
          type: actions.FETCH_MODULE_HISTORY_ADMIN,
          payload: { professionalUid: professional.id },
        });
      }

      notification(
        'success',
        enabled ? 'Conta ativada' : 'Conta desativada',
        enabled
          ? 'O usuário voltou a ter acesso ao sistema.'
          : 'O usuário foi impedido de acessar o sistema.',
      );
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.SET_USER_ENABLED_ADMIN_ERROR,
        payload: error.message,
      });
      notification(
        'error',
        'Erro ao alterar o estado da conta',
        error.message,
      );
    }
  });
}

// Tela "Últimas atualizações": páginas por chave (as chaves são datas, então a ordem
// lexicográfica é a cronológica). Rascunho não conta pra encher a página, por isso pode
// puxar mais de uma leva até ter CHANGELOG_PAGE_SIZE publicadas ou acabar.
const CHANGELOG_PAGE_SIZE = 10;
const CHANGELOG_PAGE_MAX_ROUNDS = 4;
// A leitura volta quase na hora; a pausa dá tempo de o botão mostrar que respondeu.
const CHANGELOG_LOAD_MORE_DELAY_MS = 400;

const getChangelogPageFromStore = (state) => state.App.changelogPage;

function fetchChangelogPageFromDB(beforeKey) {
  const db = getDatabase();
  const constraints = [orderByKey(), limitToLast(CHANGELOG_PAGE_SIZE)];
  if (beforeKey) {
    constraints.push(endBefore(beforeKey));
  }
  return get(query(ref(db, CHANGELOG_ENTRIES_PATH), ...constraints));
}

export function* fetchChangelogPageRequest() {
  yield takeLatest(actions.FETCH_CHANGELOG_PAGE, function* (action) {
    const reset = Boolean(action.payload?.reset);
    try {
      if (!reset) {
        yield call(sleep, CHANGELOG_LOAD_MORE_DELAY_MS);
      }
      const current = yield select(getChangelogPageFromStore);
      let beforeKey = reset ? null : current.oldestKey;
      const entries = {};
      let publishedCount = 0;
      let hasMore = true;
      let rounds = 0;
      while (hasMore && publishedCount < CHANGELOG_PAGE_SIZE && rounds < CHANGELOG_PAGE_MAX_ROUNDS) {
        rounds += 1;
        const snapshot = yield call(fetchChangelogPageFromDB, beforeKey);
        const raw = snapshot.val() || {};
        const keys = Object.keys(raw).sort();
        hasMore = keys.length === CHANGELOG_PAGE_SIZE;
        Object.assign(entries, raw);
        publishedCount += keys.filter((key) => normalizeChangelogEntry(key, raw[key]).published).length;
        if (keys.length) {
          [beforeKey] = keys;
        }
      }
      yield put({
        type: actions.FETCH_CHANGELOG_PAGE_SUCCESS,
        payload: {
          entries, hasMore, oldestKey: beforeKey, reset,
        },
      });
      const entryKeys = Object.keys(entries);
      if (entryKeys.length) {
        yield put({ type: actions.FETCH_CHANGELOG_LIKES, payload: { entryKeys } });
      }
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.FETCH_CHANGELOG_PAGE_ERROR });
    }
  });
}

const CHANGELOG_AI_ERROR_MESSAGES = {
  JIRA_API_ERROR: 'Não foi possível consultar o Jira. Tente novamente.',
  JIRA_NOT_CONFIGURED: 'A integração com o Jira não está configurada no servidor.',
  GEMINI_API_ERROR: 'A IA não conseguiu gerar os itens. Tente novamente.',
  INVALID_VERSION: 'Informe a versão no formato 1.33.4.',
};

function changelogAiErrorNotification(error, version) {
  const code = error?.response?.data?.code;
  if (code === 'NO_JIRA_ISSUES' && version) {
    return [
      'warning',
      `Nenhuma issue no Jira para a ${formatVersion(version)}`,
      'Rode o jira-sync para essa versão e tente de novo.',
    ];
  }
  if (error?.response?.status === 403) {
    return ['error', 'Apenas administradores podem gerar atualizações pelo Jira.'];
  }
  return [
    'error',
    CHANGELOG_AI_ERROR_MESSAGES[code] || 'Não foi possível concluir a geração pelo Jira. Tente novamente.',
  ];
}

function describeChangelogSync(result) {
  const created = result.created || [];
  const failed = result.failed || [];
  const remaining = result.remaining || [];
  const batchSize = result.batchSize || JIRA_SYNC_BATCH_SIZE;
  if (!result.maxExisting) {
    return [
      'info',
      'Nenhuma atualização cadastrada ainda.',
      'Cadastre a primeira manualmente: a geração pelo Jira parte da versão mais recente já cadastrada.',
    ];
  }
  const details = [];
  if (created.length) {
    details.push(created.map((item) => formatVersion(item.version)).join(', '));
  }
  if (failed.length) {
    details.push(`Falharam: ${failed.map((item) => formatVersion(item.version)).join(', ')}.`);
  }
  if (remaining.length) {
    details.push(`Faltam ${remaining.length}; clique de novo pra gerar as próximas ${batchSize}.`);
  }
  if (!created.length && !failed.length) {
    return ['info', 'Nenhuma versão nova no Jira.'];
  }
  if (!created.length) {
    return ['warning', 'Nenhum rascunho criado.', details.join(' ')];
  }
  const title = created.length === 1 ? '1 rascunho criado' : `${created.length} rascunhos criados`;
  return [failed.length ? 'warning' : 'success', title, details.join(' ')];
}

function generateChangelogItemsOnCF(idToken, version) {
  return axios.post(
    `${ROOT_URL}/generateChangelogItems`,
    { version },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function syncChangelogFromJiraOnCF(idToken) {
  return axios.post(
    `${ROOT_URL}/syncChangelogFromJira`,
    {},
    { headers: { Authorization: `Bearer ${idToken}` }, timeout: CHANGELOG_SYNC_TIMEOUT_MS },
  );
}

export function* generateChangelogItemsRequest() {
  yield takeLatest(actions.GENERATE_CHANGELOG_ITEMS, function* (action) {
    const { version } = action.payload;
    try {
      const idToken = yield call(getIdToken);
      const { data } = yield call(generateChangelogItemsOnCF, idToken, version);
      yield put({ type: actions.GENERATE_CHANGELOG_ITEMS_SUCCESS, payload: data });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.GENERATE_CHANGELOG_ITEMS_ERROR });
      notification(...changelogAiErrorNotification(error, version));
    }
  });
}

export function* syncChangelogFromJiraRequest() {
  yield takeLatest(actions.SYNC_CHANGELOG_FROM_JIRA, function* () {
    try {
      const idToken = yield call(getIdToken);
      const { data } = yield call(syncChangelogFromJiraOnCF, idToken);
      yield put({ type: actions.SYNC_CHANGELOG_FROM_JIRA_SUCCESS, payload: data });
      yield put({
        type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG,
        payload: { completeChangelog: true },
      });
      notification(...describeChangelogSync(data));
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.SYNC_CHANGELOG_FROM_JIRA_ERROR });
      notification(...changelogAiErrorNotification(error));
    }
  });
}

export function* setChangelogStatusRequest() {
  yield takeEvery(actions.SET_CHANGELOG_STATUS, function* (action) {
    const { entryKey, status } = action.payload;
    try {
      const db = getDatabase();
      yield call(() => update(ref(db), {
        [`${CHANGELOG_ENTRIES_PATH}/${entryKey}/status`]: status,
        [`${CHANGELOG_ENTRIES_PATH}/${entryKey}/visible`]: status === 'published',
      }));
      yield put({ type: actions.SET_CHANGELOG_STATUS_SUCCESS });
      yield put({
        type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG,
        payload: { completeChangelog: true },
      });
      notification(
        'success',
        status === 'published' ? 'Atualização publicada.' : 'Atualização voltou a rascunho.',
      );
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.SET_CHANGELOG_STATUS_ERROR });
      notification('error', 'Não foi possível alterar o status da atualização. Tente novamente.');
    }
  });
}

const getActiveChangelogKeyFromStore = (state) => state.App.activeChangelogKey;

// Apaga a atualização (rascunho ou publicada) e marca a versão como ignorada, pra
// "Gerar do Jira" não recriá-la. Publicada: desliga o alerta de login se era ela e
// apaga as curtidas; os feedbacks dos usuários ficam (a aba mostra pela chave).
export function* discardChangelogEntryRequest() {
  yield takeEvery(actions.DISCARD_CHANGELOG_ENTRY, function* (action) {
    const { entryKey, version, published } = action.payload;
    try {
      const db = getDatabase();
      const { currentUser } = getAuth();
      const activeKey = yield select(getActiveChangelogKeyFromStore);
      const updates = {
        [`${CHANGELOG_ENTRIES_PATH}/${entryKey}`]: null,
        [`${CHANGELOG_LIKES_PATH}/${entryKey}`]: null,
      };
      if (activeKey === entryKey) {
        updates[CHANGELOG_ACTIVE_PATH] = null;
      }
      if (version) {
        updates[`changelogSync/ignoredVersions/${getVersionSyncKey(version)}`] = {
          at: moment().format(),
          byUid: currentUser?.uid || null,
        };
      }
      yield call(() => update(ref(db), updates));
      yield put({ type: actions.DISCARD_CHANGELOG_ENTRY_SUCCESS });
      yield put({
        type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG,
        payload: { completeChangelog: true },
      });
      notification(
        'success',
        published ? 'Atualização excluída.' : 'Rascunho descartado.',
        'A versão não volta a ser gerada pelo Jira.',
      );
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.DISCARD_CHANGELOG_ENTRY_ERROR });
      notification(
        'error',
        published
          ? 'Não foi possível excluir a atualização. Tente novamente.'
          : 'Não foi possível descartar o rascunho. Tente novamente.',
      );
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(checkAppVersionRequest),
    fork(reloadApp),
    fork(checkServiceContract),
    fork(acceptServiceContractRequest),
    fork(requestSystemUpdatesChangelog),
    fork(fetchChangelogPageRequest),
    fork(markChangelogSeenRequest),
    fork(setActiveChangelogRequest),
    fork(saveSystemUpdateRequest),
    fork(generateChangelogItemsRequest),
    fork(syncChangelogFromJiraRequest),
    fork(setChangelogStatusRequest),
    fork(discardChangelogEntryRequest),
    fork(sendChangelogFeedbackRequest),
    fork(fetchMyChangelogFeedbackRequest),
    fork(fetchChangelogFeedbackRequest),
    fork(markChangelogFeedbackReadRequest),
    fork(fetchChangelogLikesRequest),
    fork(toggleChangelogLikeRequest),
    fork(checkMaintenanceRequest),
    fork(checkShowPopoverComponentToPrintRequest),
    fork(setShowPopoverComponentToPrintRequest),
    fork(updateSystemAlert),
    fork(checkSystemAlert),
    // Admin Module Manager
    fork(searchProfessionalsAdminRequest),
    fork(fetchProfessionalDataAdminRequest),
    fork(fetchProfessionalModulesAdminRequest),
    fork(updateProfessionalModulesAdminRequest),
    fork(fetchModuleHistoryAdminRequest),
    fork(setUserEnabledAdminRequest),
  ]);
}
